import React, { useState, FC, PropsWithChildren, useEffect } from "react"
import { Outlet } from "react-router-dom"

import { FirestoreError } from "firebase/firestore"
import { httpsCallable } from "firebase/functions"

import { UsersContext } from "."
import { useAuth, User } from "../authentication-context"
import { firebase } from "../../services/firebase/firebase"
import { AuthListData } from "../../functions/auth/auth-list"
import useContextUpdate from "../utils/useContextUpdate"

type UsersProviderProps = {
    route?: boolean
}

export const UsersProvider: FC<PropsWithChildren<UsersProviderProps>> = ({ route, children }) => {
    const [data, setData] = useState<User[]>([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<FirestoreError>()
    const { user } = useAuth()
    const [updateValue, update] = useContextUpdate()

    useEffect(() => {
        if (user)
            httpsCallable<AuthListData, User[]>(
                firebase.functions,
                "auth-list",
            )({ organisation: user.organisation })
                .then(result => setData(result.data))
                .catch(setError)
                .finally(() => setLoading(false))
    }, [user, updateValue])

    return (
        <UsersContext.Provider value={{ data, loading, error, update }}>
            {route ? <Outlet /> : children}
        </UsersContext.Provider>
    )
}
